import {Flex} from "reflexbox";
import React from "react";

export const koreanWarSoldierMapping = <Flex style={{flexDirection: 'column'}}>
  <Flex mb={3}>Below are the
    roles for each soldier: </Flex>
  <table style={{textAlign: 'left'}}>
    <tbody>
    <tr style={{textAlign: 'left'}}>
      <th>#</th>
      <th>Branch</th>
      <th>Duty</th>
      <th>Weapon</th>
    </tr>
    <tr>
      <td> 1.</td>
      <td>Army</td>
      <td>Lead Scout</td>
      <td>M-1</td>
    </tr>
    <tr>
      <td> 2.</td>
      <td>Army</td>
      <td>Scout</td>
      <td>M-1</td>
    </tr>
    <tr>
      <td> 3.</td>
      <td>Army</td>
      <td>Squad Leader</td>
      <td>M-1</td>
    </tr>
    <tr>
      <td> 4.</td>
      <td>Army</td>
      <td>BAR Man</td>
      <td>BAR</td>
    </tr>
    <tr>
      <td> 5.</td>
      <td>Army</td>
      <td>BAR Asst</td>
      <td>Carbine</td>
    </tr>
    <tr>
      <td> 6.</td>
      <td>Army</td>
      <td>Rifleman</td>
      <td>M-1</td>
    </tr>
    <tr>
      <td> 7.</td>
      <td>Army</td>
      <td>Group Leader</td>
      <td>Carbine</td>
    </tr>
    <tr>
      <td> 8.</td>
      <td>Army</td>
      <td>Radio Operator</td>
      <td>Carbine</td>
    </tr>
    <tr>
      <td> 9.</td>
      <td>Army</td>
      <td>Army Medic</td>
      <td>None</td>
    </tr>
    <tr>
      <td>10.</td>
      <td>Army</td>
      <td>Forward Observer</td>
      <td>Carbine</td>
    </tr>
    <tr>
      <td>11.</td>
      <td>USAF</td>
      <td>Air-Ground Controller</td>
      <td>Carbine</td>
    </tr>
    <tr>
      <td>12.</td>
      <td>USMC</td>
      <td>Asst Gunner</td>
      <td>Tripod</td>
    </tr>
    <tr>
      <td>13.</td>
      <td>USMC</td>
      <td>Gunner</td>
      <td>Mach Gun</td>
    </tr>
    <tr>
      <td>14.</td>
      <td>Navy</td>
      <td>Corpsman</td>
      <td>None</td>
    </tr>
    <tr>
      <td>15.</td>
      <td>USMC</td>
      <td>Rifleman</td>
      <td>M-1</td>
    </tr>
    <tr>
      <td>16.</td>
      <td>Army</td>
      <td>Rifleman</td>
      <td>M-1</td>
    </tr>
    <tr>
      <td>17.</td>
      <td>Army</td>
      <td>Rifleman</td>
      <td>M-1</td>
    </tr>
    <tr>
      <td>18.</td>
      <td>Army</td>
      <td>Asst Group Leader</td>
      <td>M-1</td>
    </tr>
    <tr>
      <td>19.</td>
      <td>Army</td>
      <td>Rifleman</td>
      <td>M-1</td>
    </tr>
    </tbody>
  </table>
</Flex>;